export default __webpack_public_path__ + "static/media/Electric-Boiler.455da573.jpg";